import { createTheme } from '@mui/material/styles';

const BRAND_BLUE = '#14a9e8';
const BRAND_INK = '#0b1620';

export function createAppTheme(mode) {
  return createTheme({
    palette: {
      mode,
      primary: {
        main: BRAND_BLUE,
      },
      ...(mode === 'light'
        ? {
            background: {
              default: '#ffffff',
              paper: '#ffffff',
            },
            text: {
              primary: BRAND_INK,
              secondary: '#3a4a5a',
            },
          }
        : {
            background: {
              default: '#121212',
              paper: '#1e1e1e',
            },
            text: {
              primary: '#f0f0f0',
              secondary: '#b0b0b0',
            },
          }),
    },
    typography: {
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
      h1: {
        fontWeight: 800,
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            transition: 'all 0.2s ease',
            '&:hover': {
              transform: 'translateY(-1px)',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            transition: 'all 0.2s ease',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
            },
          },
        },
      },
    },
  });
}
